import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { useRouteMatch } from 'react-router-dom';
import { ForgotPassword as ForgotPasswordComponent } from '@smorder/core';
import { NavigationLink } from '../components';
import { validateEmail } from '../utils/validate-email';

import config from '../../run-config';

const styles = theme => ({
  forgotPassword: {
    marginTop: 10,
    color: theme.palette.link.main,
  },
});

const ForgotPassword = ({ classes, match, ...props }) => {
  const successMatch = useRouteMatch(`${match.path}/success`) || {};

  const login = (
    <NavigationLink to="/login">
      <div className={classes.forgotPassword}>Zurück zum Login</div>
    </NavigationLink>
  );

  const logo = config.loginLogo;

  return (
    <ForgotPasswordComponent
      {...props}
      logo={logo}
      login={login}
      validateEmail={validateEmail}
      success={!!successMatch.isExact}
    />
  );
};


ForgotPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  match: PropTypes.object.isRequired,
  resetPassword: PropTypes.func.isRequired,
};

ForgotPassword.defaultProps = {
  isLoading: false,
};

export default withStyles(styles)(ForgotPassword);
